/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Connection_ImportedInputs */



/**
* | output |
* | --- |
* | "Already added" |
*
* @param {Private_Models_Connection_ImportedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_imported = /** @type {((inputs?: Private_Models_Connection_ImportedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_ImportedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereits hinzugefügt")
	return /** @type {LocalizedString} */ ("Already added")
});